import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    * {
        box-sizing: border-box;
    }

    html,
    body {
        height: 100%;
        width: 100%;
        line-height: 1.6;
        background-color: #fffcff !important;
        overscroll-behavior-x: none;
        font-size: 14px;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-rendering: optimizeLegibility;
        scroll-behavior: smooth;
    }

    body, input, select, textarea {
        font-family: 'Inter', sans-serif;
        -webkit-font-smoothing:antialiased;
        -webkit-tap-highlight-color:rgba(0, 0, 0, 0);
    }

    body.fontLoaded {
        font-family: 'Inter', sans-serif;
    }

    #app {
        min-height: 100%;
        min-width: 100%;
        color: #666;
    }

    p {
        margin: 8px 0 12px 0;
    }


    a, .link {
        cursor: pointer;
        text-decoration: none;
        color: rgb(98,0,255);
        transition: color 150ms;
    }

    a:hover, .link:hover {
        color: rgba(98,0,255, .6);
    }

    a.muted, .link.muted {
        color: #001233;
    }
    a.muted:hover, .link.muted:hover {
        text-decoration: underline;
    }

    a.quiet, .link.quiet {
        color: #777 !important;
    }
    a.quiet:hover, .link.quiet:hover {
        color: #555 !important;
    }

    a.breadcrumb-link {
        color: #929DB0;
        font-size: 12px;
        //font-weight: 300;
        max-width: 240px;
        display: inline-block;
    }
    a.breadcrumb-link:hover {
        text-decoration: underline;
    }
    .sticky-top-banner{
        z-index: 100000;
        position: sticky;
        top: 0;
        text-align: center;
    }
    .experience-like-h1 {
        font-size: 32px;
        font-weight: 600;
        line-height: 40px;
    }
    .tertiary-nav {
        width: 100%;
        //margin-top: 24px !important;
        grid-gap: 24px;
        border-bottom: 1px solid #E7E8F1;
    }
    .tertiary-nav.tertiary-nav-padded {
        margin-top: 12px;
    }
    .fs-18 { font-size: 18px !important; }
    .fs-16 { font-size: 16px !important; }
    .fs-14 { font-size: 14px !important; }
    .fs-13 { font-size: 13px !important; }
    .fs-12 { font-size: 12px !important; }
    input[type="color"]{
        height: 24px;
        width: 24px;
        border: none;
        padding: 0;
        border-radius: 8px;
        overflow: hidden;
        margin: 8px;
        cursor: pointer;
    }
    input[type=checkbox] {
        accent-color: rgb(98,0,225)
    }

    .input-search-icon:before {
        content: url("/search.svg");
        position: absolute;
        right: 12px;
        top: 6px;
        pointer-events: none;
    }

    .mb8px {
        margin-bottom: 8px;
    }

    .cdx-text-color {
        color: inherit;
    }

    .float-left {
        float: left;
    }
    .float-right {
        float: right;
    }
    .clearfix::after {
        content: "";
        clear: both;
        display: table;
    }
    .not-clickable {
        cursor: default !important;
    }
    .color-purple {
        color: rgb(98, 0, 255);
    }
    .rounded {
        border-radius: 4px !important;
    }
    .circle {
        border-radius: 50% !important;
    }
    .border {
        border-radius: 4px !important;
        border: 1px solid #eee !important;
    }
    .border.border-hover {
        cursor:pointer
    }
    .border.border-hover:hover {
        border: 1px solid #ddd !important;
        background: #fafafa;
    }

    .flex-vcenter {
        align-items: center;
        display: flex;
    }

    .app-blocked-overlay {
        position: fixed;
        top: 53px;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,0.2);
        z-index: 100;
    }
    .react-tel-input .flag-dropdown {
        border: 0 !important;
    }
    .pointer {
        cursor: pointer !important;
    }
    .title {
        color: #000;
        font-size: 18px;
    }

    .new-feature-tag {
        max-height: 19px;
        background: #FFC300;
        color: #fff;
        border-radius: 4px;
        padding: 2px 4px;
        font-size: 10px;
        line-height: 15px;
        display: inline-block;
        vertical-align: top;
        font-weight: 500;
    }

    .table-main {
        border-spacing: 0;
        border-collapse: separate;
        min-width: 100%;
    }
    
    .table-main thead {
        position: sticky;
        position: -webkit-sticky;
        top: 0;
        z-index: 3;
    }
    .table-main thead th {
        color: #929DB0;
        font-size: 12px;
        border-bottom: 1px solid #E7E8F1;
        padding: 12px 16px;
        text-align: left;
        white-space: nowrap;
        font-weight: 400;
        background: #fff;
        z-index: 3;
        position: sticky;
        position: -webkit-sticky;
        //top: 0;
        //box-shadow: rgba(36,18,77,0.05) inset -1px 0px 0px 0px;
    }
    .table-main thead th .th-clickable {
        cursor: pointer;
    }
    .table-main thead th .th-clickable:hover {
        color: #001233;
    }
    .table-main thead th:hover {
        //background: #FBFCFF;
    }
    .table-main thead th:hover .resizer {
        border-right: 2px solid rgba(98, 0, 255);
    }
    .th-inner-content {
        min-width: 40px !important;
    }
    .resizer {
        /* Displayed at the right side of column */
        position: absolute;
        top: 0;
        right: 0;
        width: 5px;
        cursor: col-resize;
        user-select: none;
    }
    .resizer:hover, .resizing {
        border-right: 2px solid #4002BD !important;
    }
    
    .table-main tbody {
        margin-top: 5px;
    }
    .table-main tbody td {
        background: #fff;
        border-bottom: 1px solid #eee;
        word-break: normal;
        
        padding: 12px 16px;
        vertical-align: middle;

        z-index: 1;
        position: relative;
        //box-shadow: rgba(36,18,77,0.05) inset -1px 0px 0px 0px;
        color: #001233;
    }
    .table-main tbody td .td-child-max-width {
        max-width: 400px;
    }

    .table-main tbody tr td .study-person-more-hover {
        visibility: hidden;
    }
    .table-main tbody tr td .study-person-more-hover-parent {
        position: absolute;
        right: 0;
        
        height: 24px;
        text-align: right;
        //min-width: 80px;
        margin-top: 4px;
    }
    .table-main tbody tr:hover td .study-person-more-hover-parent {
        background: #FBFCFF;
    }
    .table-main tbody tr:hover td .study-person-more-hover {
        visibility: visible;
    }
    .table-main tbody tr input[type=checkbox] {
        display: none;
    }
    .table-main tbody tr:hover input[type=checkbox], .table-main tbody tr input[type=checkbox]:checked {
        display: inline;
    }
    .table-main tbody tr:hover td {
        background-color: #FBFCFF;
    }

    .table-main tbody tr.row-selected td,
    .table-main tr.row-selected:hover td.sticky-row-style,
    .table-main tbody tr.row-selected:hover td .study-person-more-hover-parent {
        background-color: #FBFCFF;
    }

    .table-main tbody tr.row-being-viewed td,
    .table-main tr.row-being-viewed:hover td.sticky-row-style,
    .table-main tbody tr.row-being-viewed:hover td .study-person-more-hover-parent {
        background-color: #FFF9E6;
    }

    .table-main tr .sticky-row-style {
        box-shadow: #E7E8F1 inset -1px 0px 0px 0px;
        z-index: 1;
    }
    .table-main tr:hover td.sticky-row-style {
        background-color: #FBFCFF;
    }



    .docs-wrapper {
        border-top: 1px solid #eee;
    }
    .docs-wrapper.mobile {
        flex-direction: column;
    }
    .docs-body {
        flex: 1;
        padding: 48px;
        color: #444;
        line-height: 24px;
        max-width: 750px;
    }
    .docs-body.mobile {
        padding: 24px;
    }
    .docs-nav {
        border-right: 1px solid #eee;
        background: #f9f5f1;
        width: 220px;
        position: sticky;
        position: -webkit-sticky;
        top: 0;
        height: 100vh;
        overflow-y: scroll;
        padding: 32px 12px 32px 24px;
    }
    .docs-nav.mobile {
        position: relative;
        width: auto;
        height: auto;
        padding: 24px;
    }
    .docs-nav .section-header {
        margin: 32px 0 8px;
        color: #000;
        font-weight: 500;

    }
    .docs-nav .section-header:first-child {
        margin-top: 0;
    }
    .docs-nav a {
        color: #666;
        display: block;
        font-size: 13px;
        margin-bottom: 4px;
        font-weight: 500;
    }
    .docs-nav a:hover {
        //text-decoration: underline;
        color: rgb(98, 0, 255);
    }
    .docs-nav a.is-active {
        color: rgb(98, 0, 255);
        font-weight: 600;
    }

    .blockquote-notes {
        //margin: 0 16px !important;
        border-left: 1px solid #eee;
        //background-color: #FBFCFF;
        padding: 2px 16px;
        border-radius: 4px;
    }

    .disabled {
        opacity: 0.8;
        cursor: not-allowed;
    }
    .nice-element {
        background: #FBFAFC;
        padding: 12px 16px;
    }
    .nice-boxshadow {
        box-shadow: 0px 17px 100px rgba(0, 0, 0, 0.06), 0px 5.125px 30.1471px rgba(0, 0, 0, 0.0390953), 0px 2.12866px 12.5216px rgba(0, 0, 0, 0.03), 0px 0.769896px 4.5288px rgba(0, 0, 0, 0.0209047);
        border-radius: 8px;
    }
    .red { color: #EA4335; }

    .text-primary, label.text-primary { color: #001233; }
    .text-secondary { color: #929DB0; }


    .label-green { background: #D7FFE4 !important; color: #04AE3E !important; }
    .label-yellow { background: #FFF5D3 !important; color: rgb(223, 128, 7) !important; }
    .label-red { background: #FFD9D6 !important; color: #EA4335 !important; }
    .label-purple { background: #E2D4FF !important; color: #590DF5 !important; }

    .yellow { color: rgb(223, 128, 7); }

    .label-error { 
        background: #FFD9D6;
        color: white;
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 12px;
    }
    .label-warning { 
        background: #ffe788;
        color: black;
        padding: 2px 4px;
        border-radius: 4px;
        font-size: 13px;
    }
    .label-info { 
        background: #E7E8F1;
        //color: black;
        padding: 2px 4px;
        border-radius: 4px;
        font-size: 13px;
    }

    .bg-warning { background: #ffe788 !important; }
    .bg-error { background: #FFD9D6 !important; }
    .bg-white { background: #fff; }
    .bg-gray { background: #f6f6f6; }
    .bg-green { background: #ecfeed !important; }
    .relative { position: relative; }
    .inline { display: inline-block !important; }
    .inline-block { display: inline-block !important; }
    .block { display: block !important; }
    .light { font-weight: 400 !important; }
    .normal { font-weight: 400; }
    .medium { font-weight: 500 !important; }
    .strong, .bold { font-weight: 600 !important; }
    .italic { font-style: italic; }
    .black { color: black !important; }
    .gray { color: #777 !important; }
    .green { color: #00BA3F !important; }
    .text-purple, .purple { color: rgb(98, 0, 255); }
    .orange { color: orange; }
    .white { color: white; }

    .fill-green { background: #00BA3F !important; }

    hr {
        border: 0;
        border-top: 1px solid #eee;
        margin: 0;
        display: block;
    }

    ::selection {
        background: rgba(98,0,255,1);
        color: white;
    }
    h1, h2, h3, h4, h5, h6 {
        margin-top: 0;
        font-weight: 600;
        margin-bottom: 8px;
        color: #222;
    }
    h2 {
        margin: 32px 0 8px 0;
    }

    ul, li {
        margin: 0 0 8px 16px;
    }
    ul, ol {
        padding: 0;
        margin: 0 0 24px 16px;
    }
    ol li p, ul li p {
        margin: 0;
    }

    ul.tight {
        margin: 0;
        padding: 0;
    }
    ul.tight li {
        margin: 2px 0 2px 16px;
    }

    ul.screener-mass-options, ul.screener-mass-options li {
        margin: 0 0 2px 12px;
    }

    ol.onboarding {
        list-style: none;
        counter-reset: my-awesome-counter;

    }
    ol.onboarding li {
        counter-increment: my-awesome-counter;
        position: relative;
        margin-left: 32px;
        margin-bottom: 16px;
    }
    ol.onboarding li::before {
        content: counter(my-awesome-counter);
        color: white;
        font-weight: bold;
        position: absolute;
        left: -48px;
        line-height: 32px;
        width: 32px;
        height: 32px;
        top: 0;
        background: rgb(98,0,255);
        border-radius: 50%;
        text-align: center;
    }

    ol.onboarding li.onboarding-item-todo {
        color: black;
    }
    
    ol.onboarding li.onboarding-item-done::before {
        background: #eee;
    }

    ol.onboarding li.onboarding-item-done {
        color: #999;
    }
    .thin {
        font-weight: 400 !important;
    }
    .va-top {
        vertical-align: top !important;
    }
    .form-label-less-margin-bottom {
        margin-bottom: 8px !important;
    }
    .form-wrapper {
        flex-direction: row;
        flex-wrap: wrap;
        border: 1px solid #eee;
        border-radius: 4px;
        width: 800px;
        padding: 32px;
        align-items: flex-start;
    }
    .form-wrapper.plain {
        border: 0;
        padding: 0;
    }
    .form-wrapper .form-label {
        text-align: right;
        font-size: 13px;
        padding: 6px 16px 0 0;
        color: #929DB0;
        margin-bottom: 16px;
        line-height: 16px;
        font-weight: 300;
    }
    .form-wrapper .form-data {
        margin-bottom: 16px;
        position: relative;
    }
    .form-hr {
        height:0;
        border-top: 1px solid #eee;
    }
    .viewed-by {
        z-index: 100;
        border-radius: 4px;
        border: 1px solid black;
        padding: 8px 16px;
        position: sticky;
        position: -webkit-sticky;
        top: 0;
        background: #fafafa;
        font-size: 13px;
        line-height: 19px;
    }
    .theme-button-primary {
        tab-size: 4;
        display: inline-block;
        padding-left: 16px;
        padding-right: 16px;
        padding-top: 8px;
        padding-bottom: 8px;
        border: 0;
        font-size: 14px;
        font-weight: 400;
        color: white;
        background-color: rgba(98,0,255,1);
        border-radius: 4px;
        text-overflow: ellipsis;
        vertical-align: middle;
        white-space: nowrap;
        box-shadow: rgba(36,18,77,0.08) 0px 0px 0px 1px,rgba(36,18,77,0.32) 0px 4px 4px -4px;
        text-align: center;
        width: auto;
        margin: 0px;
        outline: none;
        transition: box-shadow 150ms;
        
        ::selection {
            background: #fff;
            color: rgba(98,0,255,1);
        }
    }

    .mimic-theme {
        background: #fbfafc;
        box-shadow: rgba(36, 18, 77, 0.08) 0px 0px 0px 1px;
    }

    .theme-input {
        //background: #fbfafc;
        background: #fff;
        box-shadow: rgba(36, 18, 77, 0.08) 0px 0px 0px 1px;
        border: 0;
        font-size: 14px;
        color: #000 !important;
        height: 32px;
        padding: 8px 12px;
        border-radius: 4px !important;
        width: 100%;
        :disabled {
            color: #999 !important;
        };
        :hover {
            outline: none;
            box-shadow: rgba(98, 0, 255, .5) 0px 0px 0px 1px;
        };
        :focus {
            outline: none;
            box-shadow: rgba(98, 0, 255, .5) 0px 0px 0px 1px;
        },
        ::placeholder {
            color: #555;
        }
    }
    .theme-input.error, .error-button {
        box-shadow: rgba(255, 0, 0, .5) 0px 0px 0px 1px, rgba(255, 0, 0, .3) 0px 0px 0 2px
    }
    .mw-100 {
        max-width: 100%;
    }
    .w120 {
        width: 120px !important;
    }
    .theme-input.theme-input-select {
        width: auto;
    }

    .theme-input.theme-input-screener-main {
        font-size: 15px;
        padding: 8px 12px;
        min-height: 36px;
    }

    .theme-input.theme-input-simple {
        border-radius: 0 !important;
        background: transparent;
        box-shadow: none;
        border-bottom: 1px solid rgba(36, 18, 77, 0.05);
        padding-left: 0;
        padding-right: 0;
        font-size: 13px;

        :hover {
            border-bottom: 1px solid rgba(36, 18, 77, 0.5);
            box-shadow: none;
        };
        :focus {
            border-bottom: 1px solid rgba(98, 0, 255, 1);
            box-shadow: none;
        };
    }
    .theme-input.theme-input-simple.error {
        border-bottom: 1px solid rgba(255, 0, 0, 1) !important;
        box-shadow: none !important;
    }

    .ce-block {
        border: 2px solid transparent;
        border-radius: 4px;
    }

    .ce-block:hover, .ce-block--focused {
        border: 2px solid #ddd;
    }

    .ce-toolbar__plus {
        box-shadow: rgba(36,18,77,0.08) 0px 0px 0px 1px, rgba(36,18,77,0.1) 0px 0px 8px 0px;
        background: #fff;
        width: 24px;
        height: 24px;
        border-radius: 4px;
        left: 14px;

        svg {
            color: black;
            height: 12px;
            width: 12px;
        }
    }
    .ce-toolbar__plus--hidden {
        display: flex;
    }
    .ce-toolbar__actions {
        right: 16px;
    }
    .ce-toolbar__settings-btn {
        box-shadow: rgba(36,18,77,0.08) 0px 0px 0px 1px, rgba(36,18,77,0.1) 0px 0px 8px 0px;
        background: #fff;
        width: 24px;
        height: 24px;
        border-radius: 4px;
        svg {
            color: black;
            height: 8px;
            width: 8px;
        }
    }

    .ce-toolbar__settings-btn {
        //background: rgb(98,0,255);
        //color: #fff;
        border-radius: 4px;
        overflow: hidden;
        &:hover {
            //color: #fff;
            //opacity: 0.7;
        }
    }

    .ce-toolbox__button {
        justify-content: left;
    }

    .codex-editor {
        background: #fff;
        padding: 48px;
    }

    
    .ce-toolbox {
        left: 48px;
        flex-direction: column;
        background: #fff;
        box-shadow: rgba(36,18,77,0.08) 0px 0px 0px 1px, rgba(36,18,77,0.1) 0px 0px 8px 0px;
        border-radius: 4px;
        padding: 8px 16px;
        text-align: left;
    }

    .ce-toolbox li {
        font-weight: 500;
        margin: 0 0 0 0;
        padding: 0;
        color: black;
        width: auto;
        text-align: left;
    }

    .ce-block {
        
    }
    .ce-block .ce-block__content {

    }

    .ce-block:first-child {
        
    }
    .ce-block:last-child {
        
    }

    .react-modal-size-huge {
        width: 1060px;
    }
    .__react_component_tooltip {
        text-transform: initial;
        border-radius: 4px !important;
        display: inline-block;
        font-size: 13px !important;
        left: -999em;
        opacity: 0;
        padding: 8px 12px !important;
        position: fixed;
        pointer-events: none;
        transition: opacity 0.3s ease-out;
        top: -999em;
        visibility: hidden;
        z-index: 9999;
        box-shadow: rgba(200, 200, 200, 0.1) 0px 0px 0px 1px, rgba(36, 18, 77, 0.1) 0px 4px 10px -4px !important;
        background: #fff !important;
        color: #000 !important;

        &.allow_hover,
        &.allow_click {
            pointer-events: auto;
        }

        &::before,
        &::after {
            content: "";
            width: 0;
            height: 0;
            position: absolute;
        }

        &.show {
            opacity: 1 !important;
            margin-top: 0;
            margin-left: 0;
            visibility: visible;
        }

        // Place
        &.place-top {
            &::before {
                border-left: 10px solid transparent;
                border-right: 10px solid transparent;
                bottom: -9px !important;
                left: 50%;
                margin-left: -10px;
                border-top-color: rgba(155, 155, 155, 0.1) !important;
            }
            &::after {
                bottom: -7px !important;
                border-top-color: #fff !important;
            }
        }

        &.place-bottom {
            &::before {
                border-left: 10px solid transparent;
                border-right: 10px solid transparent;
                top: -9px;
                left: 50%;
                margin-left: -10px;
                border-bottom-color: rgba(155, 155, 155, 0.1) !important;
            }

            &::after {
                bottom: -7px !important;
                border-bottom-color: #fff !important;
            }
        }

        &.place-left {
            &::before {
                border-top: 6px solid transparent;
                border-bottom: 6px solid transparent;
                right: -8px;
                top: 50%;
                margin-top: -5px;

                border-left-color: rgba(155, 155, 155, 0.1) !important;
            }

            &::after {
                border-left-color: #fff !important;
            }
        }

        &.place-right {
            &::before {
                border-top: 6px solid transparent;
                border-bottom: 6px solid transparent;
                left: -8px;
                top: 50%;
                margin-top: -5px;

                border-right-color: rgba(155, 155, 155, 0.1) !important;
            }

            &::after {
                border-right-color: #fff !important;
            }
        }

        // Wrapping
        .multi-line {
            display: block;
            padding: 2px 0;
            text-align: center;
        }
    }
    .warning { color: #ffe788; }
    .error {
        color: rgb(255,0,0, .8);
    }

    .screener-error-message {
        color: rgb(255,0,0, .8);
        font-size: 12px;
        margin: 4px 0 0 0;
    }

    .warning-box {
        background: #ffe788;
        border-radius: 4px;
        padding: 8px;
    }
    
    .warning-box-small {
        background: #ffe788;
        border-radius: 4px;
        padding: 4px 8px;
    }



    .ellipsis, .ellipsis-with-hover {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }
    .ellipsis-with-hover:hover {
        text-overflow: ellipsis;
        white-space: normal;
        word-break: break-all;
        max-height: 72px;
        overflow: hidden;
    }

    .arrow-down {
        vertical-align: middle;
        display: inline-block;
        width: 0; 
        height: 0; 
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;

        border-top: 4px solid #fff;

        &.purple {
            border-top-color: rgb(98,0,255);
        }
    }

    .arrow-down-dark {
        vertical-align: middle;
        display: inline-block;
        width: 0; 
        height: 0; 
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;

        border-top: 4px solid #000;
    }

    
    .custom-radio, .custom-checkbox {
        padding: 2px 4px;
        border-radius: 4px;
        transition: background-color 100ms;
        cursor: pointer;
        input {
            vertical-align: top;
            //margin-top: 5px;
        }
        label {
            cursor: pointer;
            display: block !important;
        }
    }
    .custom-radio:hover, .custom-checkbox:hover {
        background: #eee !important;
        cursor: pointer;
    }

    .react-datepicker-popper {
        z-index: 9999 !important;
    }
    .react-datepicker-time__input input {
        width: 100px;
    }

    /* item box */
    .select-box-header {
        flex-shrink: 0;
        padding: 8px 8px;
        font-size: 12px
        width: 104px;
        text-align: center;
        display: block;
        font-weight: 500;
        color: #999;
    }
    .select-box-header-wrapper {
        z-index: 1;
        position: sticky;
        position: -webkit-sticky;
        top: 8px;
        box-shadow: rgba(36, 18, 77, 0.05) 0px 0px 0px 1px, rgba(36, 18, 77, 0.1) 0px 2px 10px 0px;
        background: #fff;
        margin: 0 8px !important;
        border-radius: 4px;
    }
    .select-box-header-wrapper .select-box-header:first-child {
        //padding-left: 20px;
        //width: 112px;
    }
    .select-box-header-wrapper .select-box-header:last-child {
        //padding-right: 20px;
        //width: 112px;
    }
    .select-box {
        background: #f7f7f7;
        width: 96px;
        //height: 24px;
        //padding: 0 0 0 8px;
        text-align: center;
        line-height: 24px;
        display: block;
        margin: 4px;
        border-radius: 4px;
        //border: 1px solid #ccc;
        font-size: 11px;
        color: #999;
        box-sizing: border-box;
        cursor: pointer;
    }
    .select-box:hover {
        background: #ddd;
    }

    /* selected item box */
    .select-box.selected {
        //border-color: rgb(98, 0, 255);
        background: black;/*rgb(98, 0, 255);*/
        color: #fff;
    }

    /* selection container */
    .selection {
        position: relative;
    }

    /* selection box */
    .selection-border {
        background: rgba(0, 162, 255, 0.4);
        position: fixed;
        z-index: 99;
    }
    .noselect {
      -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
         -khtml-user-select: none; /* Konqueror HTML */
           -moz-user-select: none; /* Old versions of Firefox */
            -ms-user-select: none; /* Internet Explorer/Edge */
                user-select: none; /* Non-prefixed version, currently
                                      supported by Chrome, Edge, Opera and Firefox */
    }

    .modal-info {
        color: #777;
    }

    .children-flex-grow > div {
        //flex-grow: 1;
        //background-color: red;
    }

    .condi-text {
        display: flex;
        margin-top: 6px !important;
        color: #777;
    }
    .email-info-style {
        vertical-align: top;
        margin: 5px 0 0 2px;
    }

    .email-reminder {
        width: 100%;
        max-width: 100%;
        text-align: center;
        border-radius: 4px;
        border: 1px solid #999;
        background: #fff;
        color: #555;
        padding: 8px 16px;
        font-size: 13px;
        line-height: 19px;
        //box-shadow: rgba(100,100,100,.5) 0px 0px 8px -3px, rgba(222, 222, 222, .3) 0px 0px 0 1px
    }
    .email-reminder svg {
        vertical-align: top;
        margin: 3px 4px 0 0;
    }

    .select-modal-item .select-modal-item-remove {
        visibility: hidden;
    }
    .select-modal-item:hover .select-modal-item-remove {
        visibility: visible;
    }

    .account-email-footer {
        margin: 64px 0 !important;
        white-space: pre-wrap;
        font-size: 13px;
        line-height: 22px;
        text-align: center;
        color: #ccc;

        -webkit-transition: color 200ms linear;
        -ms-transition: color 200ms linear;
        transition: color 200ms linear;
    }
    .account-email-footer:hover {
        color: #777;
    }
    .clouds {
        position: absolute;
        bottom: -90px;
        left: 0;
        right: 0;
        height:150px;
        border-radius: 0 0 50px 50px;
        background:
            radial-gradient(150px 150px,white 99%,transparent 100%) -100px 0 / 300px 300px,
            radial-gradient(150px 150px,white 99%,transparent 100%) 70px 30px / 300px 300px,
            radial-gradient(50px 50px,white 99%,transparent 100%) 270px 30px / 100px 100px;
      background-repeat:no-repeat;
    }
    .shaking {
      /* Start the shake animation and make the animation last for 0.5 seconds */
      animation: shaking 1s;

      /* When the animation is finished, start again */
      animation-iteration-count: infinite;
    }

    @keyframes shaking {
      0% { transform: translate(1px, 1px) rotate(0deg); }
      10% { transform: translate(-1px, -2px) rotate(-1deg); }
      20% { transform: translate(-3px, 0px) rotate(1deg); }
      30% { transform: translate(3px, 2px) rotate(0deg); }
      40% { transform: translate(1px, -1px) rotate(1deg); }
      50% { transform: translate(-1px, 2px) rotate(-1deg); }
      60% { transform: translate(-3px, 1px) rotate(0deg); }
      70% { transform: translate(3px, 1px) rotate(-1deg); }
      80% { transform: translate(-1px, -1px) rotate(1deg); }
      90% { transform: translate(1px, 2px) rotate(0deg); }
      100% { transform: translate(1px, -2px) rotate(-1deg); }
    }

    .react-toast-notifications__toast {
        background: #fff !important;
        border-radius: 8px !important;
    }
    .react-toast-notifications__toast--success {
        
    }
    .react-toast-notifications__toast--info {

    }
    .react-toast-notifications__toast__icon-wrapper {
        border-top-left-radius: 8px !important;
        border-bottom-left-radius: 8px !important;
        padding-top: 10px !important;
        padding-bottom: 4px !important;
    }
    .react-toast-notifications__toast__content {
        color: #333;
        font-weight: 500;
        font-size: 14px !important;
        line-height: 24px !important;
    }
    .react-toast-notifications__toast__dismiss-button {
        color: #333 !important;
        padding: 10px 12px 4px 12px !important;
    }

    .checkbox-label {
        padding: 4px 0 0 2px;
        font-weight: 400;
    }

    .toggle-label {
        display: inline-block;
        padding: 6px 0 0 8px;
        font-weight: 400;
        vertical-align: top;
    }

    .basic-avatar {
        display: inline-block;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: rgba(0, 0, 255, 0.1);
        vertical-align: top;
        line-height: 24px;
        font-size: 13px;
        font-weight: 500;
        overflow: hidden;
        text-align: center;

        img {
            width: 100%;
            height: 100%;
            vertical-align: top;
        }
    }

    .all-breaks {
        white-space: pre-wrap;
    }

    .ql-editor{
        min-height:160px;
    }

    .sms-label {
        //background: #34c759;
        color: #34c759;
        border-radius: 4px 4px 0 0;
        padding: 8px 16px 6px 16px;
        font-size: 13px;
        display: block;
        margin: 0;
        border-bottom: 1px solid #34c759;
    }
    .sms-label svg {
        vertical-align: top;
        margin-top: 3px;
    }
    .sms-background {
        white-space: pre-wrap;
    }

    .grab-hand-nice-dropdown {
        color: #999;
        fontSize: 12px;
        margin: 8px 12px 0 0;
        cursor: grab;
    }
    .grab-hand-nice-dropdown:hover {
        color: black;
        background-color: rgba(36, 18, 77, 0.04);
    }

    .hover-gray-bg:hover {
        background: #f7f7f7;
        border-radius: 4px;
    }

    .question-logic-group {
        border-radius: 4px;
        background: #eee;
        padding: 8px 16px;
    }
    .question-logic-sub-group {
        border-radius: 4px;
        background: #ddd;
        padding: 8px 16px;
    }

     /* Dropdown Button */
    .dropbtn {
        background-color: #04AA6D;
        color: white;
        padding: 16px;
        font-size: 16px;
        border: none;
    }

    /* The container <div> - needed to position the dropdown content */
    .nice-submenu {
        position: relative;
    }

    .nice-submenu:after {
        content: url("/caret-right.svg");
        position: absolute;
        right: 12px;
        top: 6px;
        pointer-events: none;
    }
    .nice-submenu:hover:after {
        content: url("/caret-right-purple.svg");
    }

    /* Dropdown Content (Hidden by Default) */
    .nice-submenu-content-wrapper {
        display: none;
        position: absolute;
        z-index: 1000;
        left: 100%;
        top: -8px;
    }
    .nice-submenu-content {
        background-color: #fff;
        box-shadow: rgba(36, 18, 77, 0.05) 0px 0px 0px 1px, rgba(36, 18, 77, 0.1) 0px 2px 10px 0px;
        min-width: 160px;
        max-width: 240px;
        margin-left: 8px;
        border-radius: 4px;
        padding: 8px 0;
    }

    /* Links inside the nice-submenu */
    .nice-submenu-content div {
        //color: black;
        text-decoration: none;
        display: block;
        padding: 4px 16px;
        font-weight: 400;
        vertical-align: top;
    }

    /* Show the nice-submenu menu on hover */
    .nice-submenu:hover {
        background: #f7f7f7;
    }

    .nice-submenu:hover .dd-parent {
        color: rgba(98,0,255) !important;
    }

    .nice-submenu:hover .nice-submenu-content-wrapper {display: block;}

    .modal-x {
        cursor: pointer;
        text-align: right;
        cursor: pointer;
        margin: 28px 28px 0 32px;
    }
    .modal-x svg {
        color: #BCC4D1;
        font-size: 22px;
    }
    .modal-x svg:hover {
        color: rgb(151, 157, 168);
    }
    .modal-actions {
        margin-top: 24px !important;
        text-align: right;
    }

    .modal-actions.modal-actions-sticky {
        position: sticky;
        bottom: 0;
        background: #fff;
        padding: 24px 32px 24px 32px;
        margin: 0 -32px -32px;
        border-top: 1px solid rgb(238, 238, 238);
    }

    .video-rec-wrapper {
        position: relative;
        maxWidth: 640px;
        height: auto;
        border-radius: 8px;
        //border: 1px solid #aaa;
        background: #555;
        overflow: hidden;
    }

    .video-rec-controls {
        text-align: center;
        margin: 0 auto;
        background: #333;
        padding: 16px;
    }

    .video-rec-timer {
        display: none;
        pointer-events: none;
        color: white;
        font-size: 64px;
        line-height: 160px;
        position: absolute;
        text-align: center;
        margin: 0 auto;
        top: 116px;
        bottom: 0;
        left: 0;
        right: 0;
        width: 160px;
        height: 160px;
        background: rgba(0,0,0,.5);
        border-radius: 8px;
    }

    .recording-circle {
        width: 14px;
        height: 14px;
        background: #ff0000;
        border-radius: 50%;
        display: inline-block;
        margin: 5px 4px 0 0;
        vertical-align: top;
    }
    .recording-square {
        width: 14px;
        height: 14px;
        background: #ff0000;
        border-radius: 4px;
        display: inline-block;
        margin: 4px 4px 0 0;
        vertical-align: top;
    }

    .message-contains-html {
        white-space: normal !important;
    }

    .screener-q-scroll-margin-top {
        scroll-margin-top: 174px;
    }
    .hover-bg-gray:hover {
        background: #eee;
    }
`;

export default GlobalStyle;
